import { render, staticRenderFns } from "./DetailsSerie.vue?vue&type=template&id=ee61d63a&"
import script from "./DetailsSerie.vue?vue&type=script&lang=js&"
export * from "./DetailsSerie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports